import { ParameterTypeEnum } from "@commons/enums/parameter-type.enum";
import { IConfigChartParams } from "@src/app/interfaces/chart-params.interface";
import { PARAM_CHART_ANALOG_CONFIG, PARAM_CHART_BINARY_CONFIG, PARAM_CHART_DISTANCE_CONFIG, PARAM_CHART_ENGINE_SPEED_CONFIG, PARAM_CHART_FUEL_CONFIG, PARAM_CHART_GSM_LEVEL_CONFIG, PARAM_CHART_IGNITION_CONFIG, PARAM_CHART_SPEED_CONFIG, PARAM_CHART_TEMPERATURE_CONFIG, PARAM_CHART_VISIBLE_SATELLITES_CONFIG, PARAM_CHART_VOLTAGE_CONFIG } from "./chart-params";

export const CHART_CARS_PARAMS_CONFIG: Map<ParameterTypeEnum, IConfigChartParams> = new Map([
    [ParameterTypeEnum.Ignition, PARAM_CHART_IGNITION_CONFIG],
    [ParameterTypeEnum.Fuel, PARAM_CHART_FUEL_CONFIG],
    [ParameterTypeEnum.Speed, PARAM_CHART_SPEED_CONFIG],
    [ParameterTypeEnum.EngineSpeed, PARAM_CHART_ENGINE_SPEED_CONFIG],
    [ParameterTypeEnum.Temperature, PARAM_CHART_TEMPERATURE_CONFIG],
    [ParameterTypeEnum.Voltage, PARAM_CHART_VOLTAGE_CONFIG],
    [ParameterTypeEnum.Binary, PARAM_CHART_BINARY_CONFIG],
    [ParameterTypeEnum.Analog, PARAM_CHART_ANALOG_CONFIG],
    [ParameterTypeEnum.Distance, PARAM_CHART_DISTANCE_CONFIG],
    [ParameterTypeEnum.VisibleSatellites, PARAM_CHART_VISIBLE_SATELLITES_CONFIG],
    [ParameterTypeEnum.GSMLevel, PARAM_CHART_GSM_LEVEL_CONFIG],
]);
